import React, { useState, useCallback } from 'react';

import { getFilterPath } from './util';
import ProductList from './product-list';
import QuestionCard from './question-card';

/***
 * QuestionContainer component supports recursively rendering questions and answers
 */
const QuestionContainer = ({
    title,
    questions,
    finderPage,
    resultTitle,
    resultDescription,
    answers = [],
    startIndex = 0,
    removeLastAnswer,
}) => {
    const [selectedAnswers, setSelectedAnswers] = useState(answers);
    const [nestedQuestions, setNestedQuestions] = useState(null);
    const selectedAnswersCount = selectedAnswers.length;
    const currentQuestion = questions[selectedAnswersCount - startIndex];
    const questionnaireComplete = selectedAnswersCount - startIndex === questions.length;
    const queryFilter = getFilterPath(selectedAnswers, finderPage);

    const goBack = useCallback(
        startOver => () => {
            if (selectedAnswersCount === 0) return;
            if (removeLastAnswer && (startOver || selectedAnswersCount <= startIndex)) {
                removeLastAnswer(startOver);
            } else {
                nestedQuestions && setNestedQuestions(null);
                setSelectedAnswers(startOver ? [] : selectedAnswers.slice(0, -1));
            }
        },
        [selectedAnswers, questionnaireComplete, nestedQuestions],
    );

    const answerClick = useCallback(
        answer => {
            setSelectedAnswers([...selectedAnswers, answer]);
            if (answer.questionAndAnswers) {
                setNestedQuestions(answer.questionAndAnswers);
            }
        },
        [selectedAnswersCount],
    );
    //If the last answer has nested questionsAnswers, recursively render them
    if (nestedQuestions) {
        return (
            <QuestionContainer
                title={title}
                questions={nestedQuestions}
                finderPage={finderPage}
                resultTitle={resultTitle}
                resultDescription={resultDescription}
                answers={selectedAnswers}
                startIndex={selectedAnswersCount}
                removeLastAnswer={startOver => goBack(startOver)()}
            />
        );
    }

    return (
        <ul className="questionnaire-container">
            {!questionnaireComplete && (
                <QuestionCard
                    totalQ={startIndex + questions.length}
                    currentQ={selectedAnswersCount}
                    title={title}
                    question={currentQuestion}
                    onClick={answerClick}
                    goBack={goBack()}
                    queryFilter={queryFilter}
                />
            )}
            {questionnaireComplete && (
                <ProductList
                    title={resultTitle}
                    description={resultDescription}
                    path={queryFilter.path}
                    startOver={goBack(true)}
                    queryFilter={queryFilter}
                />
            )}
        </ul>
    );
};

export default QuestionContainer;
